$(".logo-list-slider").flickity({autoPlay:!0,groupCells:"100%",cellAlign:"center",wrapAround:!0,lazyLoad:2});
//# sourceMappingURL=/s/files/1/0135/0251/3252/t/59/assets/lcs-logo-slider.js.map?v=1642629484
